<template>
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold text-gray-900">{{ $gettext("Ventes") }}</h1>
    </div>
  </div>
  <div class="mt-8 flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table v-if="saleListingAgreements && saleListingAgreements.length > 0" class="relative min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th scope="col" class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $gettext("Commission") }}</th>
              <th scope="col" class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">{{ $gettext("Date de vente") }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr
              v-for="saleListingAgreement in saleListingAgreements"
              :key="saleListingAgreement.id"
              class="cursor-pointer hover:bg-gray-100"
              @click="$router.push({ name: 'sale-listing-agreement', params: { id: saleListingAgreement.id } })"
            >
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ saleListingAgreement.attributes.commission }} {{ saleListingAgreement.relationships.commissionType.data?.attributes?.name }}</td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ parseDate(saleListingAgreement.attributes.endAt) }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="text-center text-gray-500 text-sm py-6">
          {{ $gettext("Aucune vente trouvée.") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDate } from "@/utils/stores/date";
const { parseDate } = useDate();

defineProps({
  saleListingAgreements: {
    type: Array,
    required: true,
    default: () => [],
  },
});
</script>
